function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "VOLogo2");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M288,13.55H419L279.21,931.23H144.37L4.53,13.55h131.1L203.05,518l5,38.71h7.49l5-38.71Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M930.93,742.7c-1.24,37.45-8.74,71.16-22.47,99.88A171.85,171.85,0,0,1,854.77,910c-25,20-58.68,31.22-103.62,31.22S671.24,930,646.27,910c-25-18.73-41.2-42.45-52.44-67.42-13.73-28.72-21.23-62.43-22.47-99.88V202.08c1.24-36.2,8.74-69.92,22.47-98.63,11.24-25,27.47-49.94,52.44-68.67S706.2,3.57,751.15,3.57,829.8,16.05,854.77,34.78s42.45,43.7,53.69,68.67c13.73,28.71,21.23,62.43,22.47,98.63ZM796.09,202.08c0-25-5-42.45-17.48-57.43-6.24-6.24-16.23-10-27.46-10-23.73,0-35,17.48-40,33.71-3.74,10-5,21.23-5,33.71V742.7c0,26.22,6.24,43.7,18.73,57.43,6.24,6.24,15,10,26.22,10,23.72,0,35-15,40-33.71,3.74-8.74,5-20,5-33.71Z"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 932.22 941.22",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.c8b8dbf0.svg";
export { ForwardRef as ReactComponent };